import { COMMISSION_TYPE } from './config'

export const getSettlementAmountFormula =
(params) => {
  const {
    baseSalary,
    commissionType,
    commissionRate,
    startValue,
  } = params

  const commissionStr = commissionType === COMMISSION_TYPE.BASE
    ? '(当期支付总金额)' : `(当期支付总金额-${startValue !== null ? startValue : '动态规则下限'})`

  const rateDisplay = commissionRate !== null ? `${commissionRate}%` : '奖励比例'
  return `${`${baseSalary}元` || '司机分佣金额'} + ${commissionStr} * ${rateDisplay};`
}
